import { queryOptions } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getInstatusStatus } from "@/api/resources/instatus/api";
import { INSTATUS_REFETCH_INTERVAL } from "@/configs/instatus";

export const instatusQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "instatus"],
};

export const instatusQueries = {
  all: () =>
    queryOptions({
      queryKey: [...instatusQueryKeys.all()],
      queryFn: () => getInstatusStatus(),
      refetchInterval: INSTATUS_REFETCH_INTERVAL,
    }),
};
